import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';
import moment from 'moment';
import { productHasProgrammedVolet } from './services/rachat-allocation';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const parameters: Parameters = {
      ...option,
    };
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        optionFiscale: [
          entity?.parameters?.optionFiscale || null,
          [Validators.required],
        ],
        casExceptionnel: [entity?.parameters?.casExceptionnel || null],
        motifs: [
          entity?.parameters?.motifs || [],
          [Validators.required, Validators.minLength(1)],
        ],
        contractStartDate: [
          entity?.parameters?.contractStartDate || null,
          [Validators.required],
        ],
        rppStartDate: [
          !_.isNil(entity?.parameters?.rppStartDate)
            ? this.yearMonthToDate(entity?.parameters?.rppStartDate)
            : null,
          [
            productHasProgrammedVolet(entity?.parameters)
              ? Validators.required
              : Validators.nullValidator,
          ],
        ],
        rppEndDate: [
          !_.isNil(entity?.parameters?.rppEndDate)
            ? this.yearMonthToDate(entity?.parameters?.rppEndDate)
            : null,
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }

  yearMonthToDate(yearMonth: string) {
    return moment(yearMonth)
      .tz('Europe/Paris')
      .startOf('month')
      .add(4, 'hours')
      .format();
  }

  dateToYearMonth(date: string) {
    return moment(date).tz('Europe/Paris').format('YYYY-MM');
  }

  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }
  extract() {
    const products = _.cloneDeep(this.form.value.products);
    products.forEach(product => {
      product.parameters.rppStartDate = !_.isNil(
        product.parameters.rppStartDate,
      )
        ? this.dateToYearMonth(product.parameters.rppStartDate)
        : null;
      product.parameters.rppEndDate = !_.isNil(product.parameters.rppEndDate)
        ? this.dateToYearMonth(product.parameters.rppEndDate)
        : null;
    });
    return products;
  }
}
